// extracted by mini-css-extract-plugin
export default {"option":"OptionSelect_option__zS12t","focado":"OptionSelect_focado__23uYd"};